<div class="formfield">
  <div>
    <label for="messdienstleister">Messdienstleister</label>
    <select id="messdienstleister" [(ngModel)]="model" (change)="onChange()">
      <option value="">{{'heizcheck.messdienstleister.pleasechoose' | translate}}</option>
      @for (msp of msps; track msp) {
        <option [value]="msp">{{'heizcheck.messdienstleister.' + msp + '.label' | translate}}</option>
      }
    </select>
  </div>
</div>
